import React, { useState } from "react";
import { Card, Alert, Spin, Descriptions, Tag, Typography, Space, Divider, Input, Button, Row, Col, Tooltip, message } from "antd";
import { SafetyCertificateOutlined, CarOutlined, UserOutlined, QuestionCircleFilled, CopyOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { startGet6Digitos, startGetDetalle, setVistaResultados } from "../../../../context/actions/polizarioActions";

const { Text } = Typography;

export const PolizarioAguila = () => {
  const dispatch = useDispatch();
  const [digitosVin, setDigitosVin] = useState("");

  const { vistaResultados, loadingPolizario, elAguilaLista, elAguilaPoliza } = useSelector(
    (state) => state.polizarioReducer
  );
  const { validador1 } = useSelector((state) => state.asistenciasReducer.captura);

  const copiarTodo = () => {
    const data = elAguilaPoliza;
    const texto = `Póliza: ${data.poliza}
Cobertura: ${data.cobertura}

--- Asegurado ---
Nombre: ${data.apellido1} ${data.apellido2}, ${data.nombre}
Teléfono: ${data.telefono}
RFC: ${data.rfc}
Vigencia: ${data.fechaIni?.replace(" 00:00", "")} — ${data.fechaFin?.replace(" 00:00", "")}

--- Vehículo ---
Marca: ${data.marca}
Modelo: ${data.modelo}
Año: ${data.anio}
Placas: ${data.placas}
VIN: ${data.vin}
Dirección: ${data.direccion}`;

    navigator.clipboard.writeText(texto).then(() => {
      message.success("Datos copiados al portapapeles");
    });
  };

  return (
    <Card size="small">
      <div className="crear-servicios-v2__section-header">
        <div className="crear-servicios-v2__section-header-title">
          <SafetyCertificateOutlined />
          <span>Polizario El Águila</span>
        </div>
      </div>

      {!validador1 && (
        <Alert message="Ingrese un validador y presione Buscar" type="info" showIcon />
      )}

      {validador1 && loadingPolizario && (
        <div style={{ textAlign: "center", padding: 24 }}>
          <Spin />
        </div>
      )}

      {validador1 && !loadingPolizario && vistaResultados === 0 && (
        <Alert message="Presione Buscar para consultar" type="info" showIcon />
      )}

      {/* LISTA DE PÓLIZAS */}
      {validador1 && !loadingPolizario && vistaResultados === 1 && (
        <Space direction="vertical" style={{ width: "100%" }}>
          {elAguilaLista.length === 0 && (
            <>
              <Alert message="No se encontraron pólizas" type="warning" showIcon />
              <Row gutter={10} style={{ marginTop: 10, justifyContent: "center" }}>
                <Col>
                  <Input
                    placeholder="últimos 6 dígitos VIN"
                    size="small"
                    value={digitosVin}
                    onChange={({ target }) => setDigitosVin(target.value)}
                    onPressEnter={() => dispatch(startGet6Digitos(digitosVin))}
                  />
                </Col>
                <Col>
                  <Button
                    onClick={() => dispatch(startGet6Digitos(digitosVin))}
                    disabled={digitosVin.length !== 6}
                    type="primary"
                    size="small"
                  >
                    Buscar en VIN
                  </Button>
                </Col>
                <Col>
                  <Tooltip title="Podrías buscar por los últimos 6 dígitos del VIN"><QuestionCircleFilled /></Tooltip>
                </Col>
              </Row>
            </>
          )}
          {elAguilaLista.map((a) => (
            <Card
              key={a.elaguilaID}
              size="small"
              style={{ cursor: "pointer" }}
              onClick={() => dispatch(startGetDetalle(a.elaguilaID))}
            >
              <Space direction="vertical" size={4} style={{ width: "100%" }}>
                <Space>
                  <Text strong>{a.poliza}</Text>
                  <Tag>{a.cobertura}</Tag>
                  <Text type="secondary" style={{ fontSize: 11 }}>{a.contrato}</Text>
                </Space>
                <Divider style={{ margin: "6px 0" }} />
                <Space>
                  <UserOutlined />
                  {a.nombre}
                </Space>
                <Space>
                  <CarOutlined />
                  <Text type="secondary">
                    {a.marca} · {a.modelo} · {a.placas}
                  </Text>
                </Space>
                <Text type="secondary" style={{ fontSize: 11 }}>VIN: {a.vin}</Text>
              </Space>
            </Card>
          ))}
        </Space>
      )}

      {/* DETALLE DE PÓLIZA */}
      {validador1 && !loadingPolizario && vistaResultados === 2 && (
        <Space direction="vertical" style={{ width: "100%" }}>
          <Space wrap>
            <Text strong style={{ fontSize: 15 }}>{elAguilaPoliza.poliza}</Text>
            <Tag>{elAguilaPoliza.cobertura}</Tag>
            <Button 
              icon={<CopyOutlined />} 
              size="small" 
              onClick={copiarTodo}
            >
              Copiar todo
            </Button>
          </Space>

          <Divider orientation="left" plain style={{ margin: "8px 0" }}>
            <Space><UserOutlined /><Text type="secondary" style={{ fontSize: 12 }}>Asegurado</Text></Space>
          </Divider>
          <Descriptions column={2} size="small">
            <Descriptions.Item label="Nombre" span={2}>
              {`${elAguilaPoliza.apellido1} ${elAguilaPoliza.apellido2}, ${elAguilaPoliza.nombre}`}
            </Descriptions.Item>
            <Descriptions.Item label="Teléfono">{elAguilaPoliza.telefono}</Descriptions.Item>
            <Descriptions.Item label="RFC">{elAguilaPoliza.rfc}</Descriptions.Item>
            <Descriptions.Item label="Vigencia" span={2}>
              {`${elAguilaPoliza.fechaIni?.replace(" 00:00", "")} — ${elAguilaPoliza.fechaFin?.replace(" 00:00", "")}`}
            </Descriptions.Item>
          </Descriptions>

          <Divider orientation="left" plain style={{ margin: "8px 0" }}>
            <Space><CarOutlined /><Text type="secondary" style={{ fontSize: 12 }}>Vehículo</Text></Space>
          </Divider>
          <Descriptions column={2} size="small">
            <Descriptions.Item label="Marca">{elAguilaPoliza.marca}</Descriptions.Item>
            <Descriptions.Item label="Año">{String(elAguilaPoliza.anio)}</Descriptions.Item>
            <Descriptions.Item label="Modelo" span={2}>{elAguilaPoliza.modelo}</Descriptions.Item>
            <Descriptions.Item label="Placas">{elAguilaPoliza.placas}</Descriptions.Item>
            <Descriptions.Item label="VIN">{elAguilaPoliza.vin}</Descriptions.Item>
            <Descriptions.Item label="Dirección" span={2}>{elAguilaPoliza.direccion}</Descriptions.Item>
          </Descriptions>

          <Text
            type="secondary"
            style={{ cursor: "pointer", fontSize: 12 }}
            onClick={() => dispatch(setVistaResultados(1))}
          >
            ← Volver a lista
          </Text>
        </Space>
      )}
    </Card>
  );
};
